this.Urls = (function () {

    var Urls = {};

    var self = {
        url_patterns:{}
    };

    var _get_url = function (url_pattern) {
        return function () {
            var _arguments, index, url, url_arg, url_args, _i, _len, _ref,
                _ref_list, match_ref, provided_keys, build_kwargs;

            _arguments = arguments;
            _ref_list = self.url_patterns[url_pattern];

            if (arguments.length == 1 && typeof (arguments[0]) == "object") {
                // kwargs mode
                var provided_keys_list = Object.keys (arguments[0]);
                provided_keys = {};
                for (_i = 0; _i < provided_keys_list.length; _i++)
                    provided_keys[provided_keys_list[_i]] = 1;

                match_ref = function (ref)
                {
                    var _i;

                    // Verify that they have the same number of arguments
                    if (ref[1].length != provided_keys_list.length)
                        return false;

                    for (_i = 0;
                         _i < ref[1].length && ref[1][_i] in provided_keys;
                         _i++);

                    // If for loop completed, we have all keys
                    return _i == ref[1].length;
                }

                build_kwargs = function (keys) {return _arguments[0];}

            } else {
                // args mode
                match_ref = function (ref)
                {
                    return ref[1].length == _arguments.length;
                }

                build_kwargs = function (keys) {
                    var kwargs = {};

                    for (var i = 0; i < keys.length; i++) {
                        kwargs[keys[i]] = _arguments[i];
                    }

                    return kwargs;
                }
            }

            for (_i = 0;
                 _i < _ref_list.length && !match_ref(_ref_list[_i]);
                 _i++);

            // can't find a match
            if (_i == _ref_list.length)
                return null;

            _ref = _ref_list[_i];
            url = _ref[0], url_args = build_kwargs(_ref[1]);
            for (url_arg in url_args) {
            	var url_arg_value = url_args[url_arg];
            	if (url_arg_value === undefined || url_arg_value === null) {
            		url_arg_value = '';
            	} else {
            		url_arg_value = url_arg_value.toString();
            	}
                url = url.replace("%(" + url_arg + ")s", url_arg_value);
            }
            return '/' + url;
        };
    };

    var name, pattern, url, url_patterns, _i, _len, _ref;
    url_patterns = [
        
            [
                'submissions:api:create',
                [
                    
                    [
                        'api/create.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/create',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:eligible',
                [
                    
                    [
                        'api/submissions/%(kind)s/eligible.%(format)s',
                        [
                            
                            'kind',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/submissions/%(kind)s/eligible/',
                        [
                            
                            'kind',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:files:control\u002Dtemp\u002Dfile\u002Duploads\u002Dp',
                [
                    
                    [
                        'api/upload_temp_files/%(_0)s.%(format)s',
                        [
                            
                            '_0',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/upload_temp_files/%(_0)s/',
                        [
                            
                            '_0',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:files:temp\u002Dfile\u002Ddetect\u002Dcolor\u002Dtype',
                [
                    
                    [
                        'api/detect_color_type.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/detect_color_type/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:files:temp\u002Dfile\u002Dupload',
                [
                    
                    [
                        'api/upload_temp_file.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/upload_temp_file/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:files:temp\u002Dfile\u002Dupload\u002Dp',
                [
                    
                    [
                        'api/upload_temp_file/%(_0)s.%(format)s',
                        [
                            
                            '_0',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/upload_temp_file/%(_0)s/',
                        [
                            
                            '_0',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:files:temp\u002Dfile\u002Duploads',
                [
                    
                    [
                        'api/upload_temp_files.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/upload_temp_files/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:forgot',
                [
                    
                    [
                        'api/forgot.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/forgot',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:login',
                [
                    
                    [
                        'api/login.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/login',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:logout',
                [
                    
                    [
                        'api/logout.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/logout',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:materials',
                [
                    
                    [
                        'api/materials/%(category)s.%(format)s',
                        [
                            
                            'category',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/materials/%(category)s/',
                        [
                            
                            'category',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:oembed',
                [
                    
                    [
                        'api/oembed.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/oembed/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:profile',
                [
                    
                    [
                        'api/profile.%(format)s',
                        [
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/profile',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:submission',
                [
                    
                    [
                        'api/submissions/%(kind)s/%(pk)s.%(format)s',
                        [
                            
                            'kind',
                            
                            'pk',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/submissions/%(kind)s/%(pk)s/',
                        [
                            
                            'kind',
                            
                            'pk',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:api:submission\u002Dcreate',
                [
                    
                    [
                        'api/submissions/%(kind)s.%(format)s',
                        [
                            
                            'kind',
                            
                            'format',
                            
                        ],
                    ],
                    
                    [
                        'api/submissions/%(kind)s/',
                        [
                            
                            'kind',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:closed',
                [
                    
                    [
                        'closed/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:create',
                [
                    
                    [
                        'create\u002Daccount/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:create_with_email',
                [
                    
                    [
                        'create\u002Daccount/%(hash)s/',
                        [
                            
                            'hash',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:eligible\u002Dpopup',
                [
                    
                    [
                        'eligible\u002Dprojects/%(category)s/',
                        [
                            
                            'category',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:forgot',
                [
                    
                    [
                        'forgot/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:help',
                [
                    
                    [
                        'help/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:login',
                [
                    
                    [
                        'login/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:materials\u002Dpopup',
                [
                    
                    [
                        'materials/%(category)s/',
                        [
                            
                            'category',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:profile',
                [
                    
                    [
                        'profile/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:reset',
                [
                    
                    [
                        'reset/%(code)s/',
                        [
                            
                            'code',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:rules',
                [
                    
                    [
                        'rules\u002Dand\u002Dspecifications/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:submission\u002Dpopup',
                [
                    
                    [
                        'submission/%(kind)s/%(id)s/%(uploads)s/',
                        [
                            
                            'kind',
                            
                            'id',
                            
                            'uploads',
                            
                        ],
                    ],
                    
                    [
                        'submission/%(kind)s/%(id)s/',
                        [
                            
                            'kind',
                            
                            'id',
                            
                        ],
                    ],
                    
                    [
                        'submission/%(kind)s/',
                        [
                            
                            'kind',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'submissions:submissions',
                [
                    
                    [
                        '',
                        [
                            
                        ]
                    ]
                    
                ]
            ]
        
    ];
    self.url_patterns = {};
    for (_i = 0, _len = url_patterns.length; _i < _len; _i++) {
        _ref = url_patterns[_i], name = _ref[0], pattern = _ref[1];
        self.url_patterns[name] = pattern;
        url = _get_url(name);
        Urls[name] = url;
        Urls[name.replace(/-/g, '_')] = url;
    }

    return Urls;
})();



//////////////////
// WEBPACK FOOTER
// ./assets/js/django_js_submissions/reverse.js
// module id = 71
// module chunks = 0